export default __webpack_public_path__ + "static/media/sky-chest-close-tab.7930bdc6.png";